import { Link } from 'react-router-dom';
import { Col, Container } from 'reactstrap';
import { Error4 } from '../../../../data/pages/Pages';
import { routes } from '../../../../routers/routes';
import { useTranslation } from 'react-i18next';

const Error404 = ({goto, buttonLabel}: {goto?: string; buttonLabel?: string}) => {
  const { t } = useTranslation();
  return (
    <div className="page-wrapper compact-wrapper" id="pageWrapper">
      <div className="error-wrapper">
        <Container>
          <div className="svg-wrraper">
            <Error4 />
          </div>
          <Col md="8" className="offset-md-2">
            <h3>{t('global.errors.404')}</h3>
            <p className="sub-content">{t('global.errors.404Message')}</p>
            <Link to={goto ?? routes.Dashboard.Default} className="btn btn-primary btn-lg">
              {buttonLabel ?? t('global.backToHomePage')}
            </Link>
          </Col>
        </Container>
      </div>
    </div>
  );
};

export default Error404;
